var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "regist selectClubs" }, [
    _c(
      "form",
      {
        ref: "favoriteClubForm",
        attrs: { method: "post" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c("input", {
          attrs: { name: _vm.dataCsrfName, type: "hidden" },
          domProps: { value: _vm.dataCsrf },
        }),
        _vm._v(" "),
        _c("input", {
          attrs: { name: "token", type: "hidden" },
          domProps: { value: _vm.dataToken },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.jsonPatchForUserInfo,
              expression: "jsonPatchForUserInfo",
            },
          ],
          attrs: { name: "userinfo_patch", type: "hidden" },
          domProps: { value: _vm.jsonPatchForUserInfo },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.jsonPatchForUserInfo = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._l(_vm.leagues, function (league) {
          return _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectedLeague,
                expression: "selectedLeague",
              },
            ],
            key: league,
            staticClass: "hiddenTrig",
            attrs: { type: "radio", name: "league", id: "league" + league },
            domProps: {
              value: league,
              checked: _vm._q(_vm.selectedLeague, league),
            },
            on: {
              change: function ($event) {
                _vm.selectedLeague = league
              },
            },
          })
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "leagueToggle" },
          [
            _c(
              "ul",
              { staticClass: "selectLeague" },
              _vm._l(_vm.leagues, function (league) {
                return _c(
                  "li",
                  {
                    key: league,
                    attrs: { tabindex: 0 },
                    on: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.selectLeague(league)
                      },
                    },
                  },
                  [
                    _c(
                      "label",
                      {
                        class: {
                          active: _vm.selectedLeague === league,
                          [league.toLowerCase()]: true,
                        },
                        attrs: { for: "league" + league },
                      },
                      [_vm._v(_vm._s(league))]
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm._l(_vm.leagues, function (league) {
              return _c(
                "ul",
                { class: ["clubList", "setting", league.toLowerCase()] },
                _vm._l(_vm.getSpecifiedClubTeams(league), function (club) {
                  return _c("li", [
                    _c("div", { staticClass: "club-team" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.emblemImagePath(club.emblemImg),
                          alt: club.teamName,
                        },
                      }),
                      _vm._v(
                        _vm._s(club.teamName) + "\n                        "
                      ),
                      _c(
                        "label",
                        {
                          staticClass: "favorite-club",
                          attrs: { tabindex: _vm.getTabIndex(league) },
                          on: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.checkFavoriteClub.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.favoriteClubs,
                                expression: "favoriteClubs",
                              },
                            ],
                            attrs: {
                              name: "favorite-status",
                              type: "checkbox",
                            },
                            domProps: {
                              value: club.clubCode,
                              checked: Array.isArray(_vm.favoriteClubs)
                                ? _vm._i(_vm.favoriteClubs, club.clubCode) > -1
                                : _vm.favoriteClubs,
                            },
                            on: {
                              click: _vm.checkFavoriteClub,
                              change: function ($event) {
                                var $$a = _vm.favoriteClubs,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = club.clubCode,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.favoriteClubs = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.favoriteClubs = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.favoriteClubs = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b",
                            {
                              attrs: {
                                "aria-label": `お気に入りクラブが${_vm.getArealabel(
                                  _vm.favoriteClubs,
                                  club.clubCode
                                )}`,
                              },
                            },
                            [_vm._v("★")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      club.clubCode !== "C2" && club.clubCode !== "G2"
                        ? _c(
                            "label",
                            {
                              staticClass: "mail-setting",
                              attrs: { tabindex: _vm.getTabIndex(league) },
                              on: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.checkAcceptContact.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.acceptContacts,
                                    expression: "acceptContacts",
                                  },
                                ],
                                attrs: {
                                  name: "email-subscription",
                                  type: "checkbox",
                                },
                                domProps: {
                                  value: club.clubCode,
                                  checked: Array.isArray(_vm.acceptContacts)
                                    ? _vm._i(
                                        _vm.acceptContacts,
                                        club.clubCode
                                      ) > -1
                                    : _vm.acceptContacts,
                                },
                                on: {
                                  click: _vm.checkAcceptContact,
                                  change: function ($event) {
                                    var $$a = _vm.acceptContacts,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = club.clubCode,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.acceptContacts = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.acceptContacts = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.acceptContacts = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "b",
                                {
                                  attrs: {
                                    "aria-label": `メール配信が${_vm.getArealabel(
                                      _vm.acceptContacts,
                                      club.clubCode
                                    )}`,
                                  },
                                },
                                [_c("i", { staticClass: "fas fa-envelope" })]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ])
                }),
                0
              )
            }),
            _vm._v(" "),
            _c("ul", { staticClass: "clubList setting jleague" }, [
              _c("li", [
                _c(
                  "label",
                  {
                    staticClass: "mail-setting",
                    attrs: { tabindex: 0 },
                    on: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.linkAcceptJleagueContact.apply(
                          null,
                          arguments
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                        Ｊリーグからのメールを受け取る\n                        "
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.acceptContacts,
                          expression: "acceptContacts",
                        },
                      ],
                      attrs: { value: "JL", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.acceptContacts)
                          ? _vm._i(_vm.acceptContacts, "JL") > -1
                          : _vm.acceptContacts,
                      },
                      on: {
                        click: _vm.linkAcceptJleagueContact,
                        change: function ($event) {
                          var $$a = _vm.acceptContacts,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "JL",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.acceptContacts = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.acceptContacts = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.acceptContacts = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm._m(1),
                  ]
                ),
              ]),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "btnSpace duo" }, [
          _c(
            "button",
            {
              staticClass: "return",
              attrs: { type: "button" },
              on: { click: _vm.backToHome },
            },
            [_vm._v("メニューに戻る")]
          ),
          _vm._v(" "),
          _c("button", { attrs: { disabled: _vm.isSubmit, type: "submit" } }, [
            _vm._v("登録"),
          ]),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "aCt" }, [
      _vm._v("\n            お気に入りクラブを選択してください。"),
      _c("br"),
      _vm._v(
        "\n            ワンタッチパスID登録しているクラブは、お気に入りクラブを解除できません。\n        "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("b", [_c("i", { staticClass: "fas fa-envelope" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }